import { makeStyles } from '@material-ui/core';

import { IsolvedLogoFullDark } from '../../icons/IsolvedLogoFullDark';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 30,
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return <IsolvedLogoFullDark classes={{ svg: classes.svg }} />;
};

export default LogoFull;
